export default __webpack_public_path__ + "static/media/cpp.a776a608.svg";